import formSubmit from '../modules/formSubmit';
import isValidEmail from '../functions/isValidEmail';
import { querySelectorId } from '../functions/querySelectors';
import { FORM_ROW_CLASS, FORM_ROW_ERROR_CLASS, BEFORE_SUBMIT_EVENT } from '../config/main';
import successProcess from '../functions/successProcess';

const NEWSLETTER_FORM_ID = 'newsletter-box-form';
const EMAIL_ID = 'newsletter-email';
const AGREE_ID = 'newsletter-agree';

let formSuccess = function(event) {
  successProcess(this);
};

let beforeSubmit = function(event) {
  let email = querySelectorId(EMAIL_ID);
  let agree = querySelectorId(AGREE_ID);

  let agreeWrap = agree.closest(`.${FORM_ROW_CLASS}`);
  let emailWrap = email.closest(`.${FORM_ROW_CLASS}`);

  emailWrap.classList.remove(FORM_ROW_ERROR_CLASS);
  agreeWrap.classList.remove(FORM_ROW_ERROR_CLASS);

  if (email && email.value && isValidEmail(email.value) && agree && agree.checked) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();

  if (!(email && email.value && isValidEmail(email.value)) && emailWrap) {
    emailWrap.classList.add(FORM_ROW_ERROR_CLASS);
  }

  if (!(agree && agree.checked) && agreeWrap) {
    agreeWrap.classList.add(FORM_ROW_ERROR_CLASS);
  }
};

export function newsletterBlog() {
  let form = querySelectorId(NEWSLETTER_FORM_ID);

  if (form) {
    formSubmit(form);
    form.addEventListener('formSuccess', formSuccess);
    form.addEventListener(BEFORE_SUBMIT_EVENT, beforeSubmit);
  }
}
